import { render, staticRenderFns } from "./ViewHighscore.vue?vue&type=template&id=923499fc&"
import script from "./ViewHighscore.vue?vue&type=script&lang=js&"
export * from "./ViewHighscore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports